import React from 'react';
import { BookOpenIcon, GiftIcon, WrenchIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { images } from '../data/links';
const stats = [{
  icon: BookOpenIcon,
  value: '6',
  label: 'Premium Volumes'
}, {
  icon: GiftIcon,
  value: '5',
  label: 'Professional Bonuses'
}, {
  icon: WrenchIcon,
  value: '30+',
  label: 'Decision Tools'
}];
export function Hero() {
  return <header className="w-full bg-mist" data-id="element-152" data-mp="1274n7mu23c66">
      <div className="bg-ink px-4 py-2.5 text-center text-xs font-semibold text-white sm:text-sm" data-id="element-153" data-mp="xa4ef45tnvbd">
        Special introductory price: <span className="text-gold" data-id="element-154" data-mp="s9q7xqjvctfg">USD $27</span> · Instant digital access
      </div>

      <div className="mx-auto max-w-6xl px-5 pb-10 pt-8 sm:pt-12 lg:grid lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-12 lg:pb-16 lg:pt-16" data-id="element-155" data-mp="nbeyvi1eemya">
        <div data-id="element-156" data-mp="382fdzkwc8ydc">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand sm:text-sm" data-id="element-157" data-mp="382p9fo05jxqf">
            Praxis & Motor Planning Clinical Pathway™
          </p>
          <h1 className="mt-3 font-heading text-[2.2rem] font-semibold leading-[1.06] text-ink sm:text-5xl lg:text-[3.4rem]" data-id="element-158" data-mp="3j6fylr125fed">
            Organize a Pediatric Praxis Case in <span className="text-cta" data-id="element-159" data-mp="399bb9nvh7dvz">15 Minutes</span> — Without Getting Lost in Theory
          </h1>
          <p className="mt-5 text-[1.05rem] leading-relaxed text-ink/75 sm:text-lg" data-id="element-160" data-mp="3e8ecex8c4zyo">
            A step-by-step educational reasoning system designed to help Pediatric Occupational Therapists organize motor
            planning observations, explore possible praxis-related difficulties, identify missing information, and develop
            clearer working hypotheses.
          </p>

          <img src={images.mockup} alt="The Praxis & Motor Planning Clinical Pathway: 6 volumes, decision toolkit and 5 bonuses" className="mx-auto mt-6 w-full max-w-md lg:hidden" data-id="element-161" data-mp="2vi55ja1lsk0n" />

          <ul className="mt-6 grid grid-cols-3 gap-2 sm:gap-3" data-id="element-162" data-mp="2lk8vklkejv44">
            {stats.map(s => <li key={s.label} className="rounded-2xl bg-white px-2 py-3 text-center ring-1 ring-line" data-id="element-163" data-mp="s3mahuslbkuo">
                <s.icon className="mx-auto h-5 w-5 text-brand" aria-hidden="true" data-id="element-164" data-mp="na08qxnyt1dn" />
                <p className="mt-1 font-heading text-2xl font-bold text-ink" data-id="element-165" data-mp="id048r6rk6on">{s.value}</p>
                <p className="text-[11px] font-semibold leading-tight text-ink/65 sm:text-xs" data-id="element-166" data-mp="de6r4zve2hp0">{s.label}</p>
              </li>)}
          </ul>

          <div className="mt-7" data-id="element-167" data-mp="161t2iuauyqmf">
            <CtaButton id="first-cta" label="Get the Praxis & Motor Planning Clinical Pathway™" data-id="element-168" data-mp="161j88uis5xax" />
            <p className="mt-4 text-center text-sm text-ink/65 sm:text-left" data-id="element-169" data-mp="111ybmqr3211d">
              Instant digital access · One-time payment of USD $27 · Lifetime access · 7-Day Guarantee
            </p>
          </div>
        </div>

        <div className="hidden lg:block" data-id="element-170" data-mp="3lui8konbuvkb">
          <img src={images.mockup} alt="The Praxis & Motor Planning Clinical Pathway: 6 volumes, decision toolkit and 5 bonuses" className="w-full" data-id="element-171" data-mp="3hrdbj1m0nm32" />
        </div>
      </div>

      <div className="border-y border-line bg-white px-5 py-7" data-id="element-172" data-mp="21a4rlpufu83c">
        <div className="mx-auto flex max-w-3xl flex-col items-center gap-4 text-center lg:flex-row lg:justify-between lg:text-left" data-id="element-173" data-mp="218jubsgqob1s">
          <div data-id="element-174" data-mp="2b0zf0xjf7dqd">
            <p className="text-sm font-extrabold uppercase tracking-[0.12em] text-danger" data-id="element-175" data-mp="2b1r7w0lmuxcy">This special offer ends in:</p>
            <p className="mt-1 text-sm text-ink/65" data-id="element-176" data-mp="2fzj1r05u8tjs">
              Special introductory price: <strong className="text-ink" data-id="element-177" data-mp="2kxkivfjpeism">USD $27</strong>
            </p>
          </div>
          <CountdownTimer size="md" data-id="element-178" data-mp="2p1jzrz8wbjmi" />
          <p className="flex items-center gap-1.5 text-sm text-ink/65" data-id="element-179" data-mp="2oye7yc8vu3n3">
            <ShieldCheckIcon className="h-4 w-4 text-ok" aria-hidden="true" data-id="element-180" data-mp="2tyafumkpaf7x" />
            Secure checkout · Instant access
          </p>
        </div>
      </div>
    </header>;
}